import React from "react";
import { useLocation, useRouteMatch } from "react-router";
import { useAccount } from "../../../../hooks/client";
import { withLoanForm } from "../../../../components/fairGoForm/withLoanForm";
import { Wrapper } from "./payOverThreeRepayments.styles";
import { Bell } from "../../../../components/icons";
import { MANAGE_ARREARS_ROUTE } from "../IncreaseRepayments/route.constants";
import { ManageRepaymentForm } from "../../components/manageRepaymentForm";
import { Wrapper as ModalWrapper } from "../../components/manageMyRepaymentModal/manageMyRepaymentModal.styles";
import { Wrapper as FormWrapper } from "../IncreaseRepayments/components/increaseRepaymentsForms.styles";
import { getPayOverThreeRepaymentsEndpoint } from "../../../../services/apiRoutes";
import { formatMoney } from "../../../../utils/helpers/stringHelper";

const ModalMessage = () => {
  return (
    <ModalWrapper>
      <h3>Thank You</h3>
      <p>
        We have received your request to spread your arrears over the next three repayments.
      </p>
    </ModalWrapper>
  );
};

export const _PayOverThreeRepaymentsForm = ({ accountId }) => {
  const { arrearsValue } = useAccount(accountId) || {};
  const formattedArrearsValue = formatMoney(arrearsValue);

  return (
    <Wrapper>
      <div className="innear-arrears-wrapper">
        <h3>
          You will be paying an additional {formattedArrearsValue} spread over
          your next 3 repayments.
        </h3>
        <div className="ccr-box">
          <div className="icon-background">
            <Bell className="bell-icon" />
          </div>
          <p>
            Please note that if your account is more than 14 days in arrears, it
            may affect your credit file (CCR).
          </p>
        </div>
      </div>
    </Wrapper>
  );
};

const PayOverThreeRepaymentsForm = withLoanForm(_PayOverThreeRepaymentsForm);

export const PayOverThreeRepayments = ({ accountId }) => {
  const { path } = useRouteMatch();
  const matchPayOverThreePayments =
    path + MANAGE_ARREARS_ROUTE.PAY_FULL_THREE_REPAYMENTS;
  const { pathname } = useLocation();
  const isActive = matchPayOverThreePayments === pathname;

  return (
    <FormWrapper>
      <ManageRepaymentForm
        buttonText="I Agree And Confirm My Request"
        endpoint={getPayOverThreeRepaymentsEndpoint(accountId)}
        initialValues=""
        modalMessage={<ModalMessage />}
        isActive={isActive}
      >
        <PayOverThreeRepaymentsForm accountId={accountId} />
      </ManageRepaymentForm>
    </FormWrapper>
  );
};
